export function stripBase64ImagePrefix(base64String: string) {
  // Step 1: Validate input is a string
  if (typeof base64String !== 'string') {
    throw new TypeError('Input must be a string')
  }

  // Step 2: Check if it's an image data URL
  if (!base64String.startsWith('data:image/')) {
    return base64String // Not an image data URL; return as-is
  }

  // Step 3: Find the comma delimiter
  const commaIndex = base64String.indexOf(',')
  if (commaIndex === -1) {
    return base64String // Malformed URL (no comma); return as-is
  }

  // Step 4: Extract the prefix and check for Base64 encoding
  const prefix = base64String.substring(0, commaIndex)
  if (!prefix.includes(';base64')) {
    return base64String // Not Base64-encoded; return as-is
  }

  // Step 5: Return raw Base64 data
  return base64String.substring(commaIndex + 1)
}
